import React from "react";
import { useState } from "react";
import NavBar from "../NavBar";
import Box from "@mui/material/Box";
import IconButtonMR from "components/Viewer3D/ui-components/IconButton/IconButton";

import Divider from "../Divider";

import ReturnOff from "../icons/PulsanteReturnSpento";
import ResetOff from "../icons/PulsanteResetSpento";
import InfoOff from "../icons/PulsanteInfoSpento";
import InfoOn from "../icons/PulsanteInfoAcceso";
import MenuOff from "../icons/PulsanteMenuSpento";
import MenuOn from "../icons/PulsanteMenuAcceso";

import DrawOff from "../icons/PulsanteDrawSpento";
import DrawOn from "../icons/PulsanteDrawAcceso";

import RulerOff from "../icons/PulsanteRulerSpento";
import RulerOn from "../icons/PulsanteRulerAcceso";

import ScreenOff from "../icons/PulsanteScreenshotSpento";
import ScreenOn from "../icons/PulsanteScreenshotAcceso";

import HelpOff from "../icons/PulsanteHelpSpento";
import HelpOn from "../icons/PulsanteHelpAcceso";

import VisibilityOff from "../icons/PulsanteVisibilitySpento";
import VisibilityOn from "../icons/PulsanteVisibilityAcceso";

import BoxContainer from "../../ui-components/BoxContainer/BoxContainer";

import Stack from "@mui/material/Stack";
import SvgIcon from "@mui/material/SvgIcon";
import MarmoRealLogoCompleto from "components/Viewer3D/ui-logo/MarmoRealLogoCompleto";
import ActionContainer from "../ActionContainer/ActionContainer";
import ButtonsContainer from "components/Viewer3D/ui-components/ButtonsContainer/ButtonsContainer";
import SquareButton from "components/Viewer3D/ui-components/SquareButton/SquareButton";



interface NavBarComponentProps {
    heightDesktop: string
    modelName: string
    material: string
    dimension: string
    dimInch: string
    onReset: () => void
    onGoBack: () => void
    onClickMeasure: () => void
    onClickDraw: () => void
    measureOn: boolean
    drawOn: boolean
    onToggleVisibility: () => void
    visibility: boolean
    onTakeScreen: () => void
}

export default function NavBarComponent(props: NavBarComponentProps) {
    const [showHelp, setHelp] = useState<boolean>(false);
    const [showInfo, setInfo] = useState<boolean>(false);
    const [showMenu, setMenu] = useState<boolean>(false);

    return (
        <NavBar height={props.heightDesktop}>
            <Box
                component={"div"}
                display={"flex"}
                width={"100%"}
                sx={{
                    position: "relative",
                    zIndex: "1300",
                    height: "100%",
                    gap: "8px"
                }}
            >
                <IconButtonMR
                    icon={<ReturnOff viewBox="0 0 48 48" width={"2.5vw"} height={props.heightDesktop} />}
                    onClick={() => props.onGoBack()}
                    height="60px"
                />
                <Divider />
                <IconButtonMR
                    state={showHelp}
                    iconStateOff={<HelpOff viewBox="0 0 48 48" width={"2.5vw"} height={props.heightDesktop} />}
                    iconStateOn={<HelpOn viewBox="0 0 48 48" width={"2.5vw"} height={props.heightDesktop} />}
                    onClick={() => {setHelp(!showHelp); setInfo(false); setMenu(false)}}
                    height="60px"
                />
                <BoxContainer
                    visible={showHelp}
                    position={{ top: "10.38dvh", left: "1.67vw", width: "30vw", height:"auto", gap: "0px" }}
                    titleBox={"Help"}
                    titleDescription={["Drag", "Pinch", "Two fingers drag"]}
                    description={["Rotation", "Zoom", "Panning"]}
                    asInfoBlock={false}
                />
            </Box>

            <Box
                component={"div"}
                display={"flex"}
                width={"100%"}
                justifyContent={"center"}
                alignItems={"center"}
                sx={{
                    zIndex: "1500",
                    height: "100%",
                }}
            >
                <SvgIcon viewBox={"0 0 215 60"} sx={{ width: 215, height: props.heightDesktop }}>
                    <MarmoRealLogoCompleto />
                </SvgIcon>
            </Box>

            <Box
                component={"div"}
                //ref={refAnchor}
                display={"flex"}
                width={"100%"}
                justifyContent={"right"}
                alignItems={"center"}
                sx={{
                    zIndex: "1400",
                    height: "100%",
                }}
            >
                <Stack
                    direction={"row"}
                    gap={"8px"}
                    display={"flex"}
                    height={"100%"}
                >
                    <IconButtonMR
                        icon={<ResetOff viewBox="0 0 48 48" width={"2.5vw"} height={props.heightDesktop} />}
                        onClick={() => props.onReset()}
                        height="60px"
                    />
                    <Divider />
                    <IconButtonMR
                        state={showInfo}
                        iconStateOff={<InfoOff viewBox="0 0 48 48" width={"2.5vw"} height={props.heightDesktop} />}
                        iconStateOn={<InfoOn viewBox="0 0 48 48" width={"2.5vw"} height={props.heightDesktop} />}
                        onClick={() => {setInfo(!showInfo); setHelp(false); setMenu(false)}}
                        height="60px"
                    />
                    <Divider />
                    <IconButtonMR
                        state={showMenu}
                        iconStateOff={<MenuOff viewBox="0 0 48 48" width={"2.5vw"} height={props.heightDesktop} />}
                        iconStateOn={<MenuOn viewBox="0 0 48 48" width={"2.5vw"} height={props.heightDesktop} />}
                        onClick={() => {setMenu(!showMenu); setHelp(false); setInfo(false)}}
                        height="60px"
                    />

                    <BoxContainer
                        visible={showInfo}
                        position={{ top: "10.38dvh", right: "1.67vw", width: "40vw", height: "auto", gap: "0px" }}
                        titleBox={"Block info"}
                        titleDescription={["Model name:", "Material:", "Dimensions:", "Dimensions:"]}
                        description={[props.modelName, props.material, props.dimension, props.dimInch]}
                        asInfoBlock={true}
                    />

                    <ActionContainer
                        visible={showMenu}
                    >
                        <ButtonsContainer
                            title='Tools'
                        >
                            <SquareButton
                                onClick={() => {props.onClickDraw()}}
                                iconOff={<DrawOff viewBox="0 0 48 48" />}
                                iconOn={<DrawOn viewBox="0 0 48 48" />}
                                state={props.drawOn}
                                text={"Draw"}
                            />

                            <SquareButton
                                onClick={() => {props.onClickMeasure(); }}
                                iconOff={<RulerOff viewBox="0 0 48 48" />}
                                iconOn={<RulerOn viewBox="0 0 48 48" />}
                                state={props.measureOn}
                                text={"Ruler"}
                            />

                            <SquareButton
                                onClick={() => {props.onTakeScreen(); }}
                                iconOff={<ScreenOff viewBox="0 0 48 48" />}
                                iconOn={<ScreenOn viewBox="0 0 48 48" />}
                                text={"Screenshot"}
                                state={true}
                            />

                            <SquareButton
                                onClick={() => {props.onToggleVisibility();}}
                                iconOff={<VisibilityOff viewBox="0 0 54 48" />}
                                iconOn={<VisibilityOn viewBox="0 0 54 48" />}
                                text={"Visibility"}
                                state={props.visibility}
                            />
                        </ButtonsContainer>
                    </ActionContainer>
                </Stack>
            </Box>
        </NavBar>
    )
}